import React from "react";
import { Card, Tag, Space, Avatar, Empty, Button } from "antd";
import ReplyBox from "./ReplyBox";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import { getInitials } from "./TicketList";
import { UserOutlined } from "@ant-design/icons";

dayjs.extend(advancedFormat);

const statusColors = {
  OPEN: { bg: "#e6f7ff", color: "#1890ff" },
  IN_PROGRESS: { bg: "#fffbe6", color: "#fa8c16" },
  RESOLVED: { bg: "#f6ffed", color: "#52c41a" },
  CLOSED: { bg: "#fff1f0", color: "#f5222d" },
};

export default function TicketDetails({ ticket, onShowUserInfo, isCollapsed }) {
  if (!ticket) return <Empty description="Select a ticket" />;

  return (
    <>
      <Card
        style={{
          borderRadius: 8,
          boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
        }}
      >
        {/* header Section */}
        <div
          style={{
            borderBottom: "1px solid #f0f0f0",
            paddingBottom: 20,
            marginBottom: 20,
            fontFamily: "Inter, sans-serif",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 8,
            }}
          >
            <h2 style={{ fontSize: 16, fontWeight: 700, margin: 0 }}>
              {ticket.category || "No category"}
            </h2>

            {!isCollapsed && (
              <Button
                type="default"
                icon={<UserOutlined />}
                onClick={onShowUserInfo}
                style={{ borderRadius: 6 }}
              >
                User Info
              </Button>
            )}
          </div>

          <Space size={4}>
            {ticket.status && (
              <Tag
                color="processing"
                style={{
                  borderRadius: 3,
                  fontFamily: "Inter",
                  backgroundColor: statusColors[ticket.status]?.bg || "#f0f0f0",
                  color: statusColors[ticket.status]?.color || "#000",
                  fontWeight: 500,
                }}
              >
                {ticket.status}
              </Tag>
            )}
            {ticket.category && (
              <Tag
                style={{
                  borderRadius: 3,
                  backgroundColor: "#f3e8ff",
                  color: "#722ed1",
                  fontFamily: "Inter",
                  fontWeight: 500,
                }}
              >
                {ticket.category}
              </Tag>
            )}
          </Space>
        </div>

        {/* message body */}
        <div
          style={{
            display: "flex",
            gap: 12,
            marginBottom: 24,
            fontFamily: "Inter, sans-serif",
          }}
        >
          <Avatar style={{ width: 40, height: 40, fontFamily: "Inter" }}>
            {getInitials(ticket.user)}
          </Avatar>
          <div style={{ flex: 1 }}>
            <div
              style={{
                fontWeight: 600,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span>
                {ticket.user?.firstName} {ticket.user?.lastName}
              </span>
              <span style={{ fontWeight: 400, color: "#999", fontSize: 12 }}>
                {ticket.createdAt
                  ? dayjs(ticket.createdAt).format("Do [of] MMMM [at] h a")
                  : ""}
              </span>
            </div>
            <p
              style={{
                marginTop: 12,
                color: "#444",
                fontSize: 13,
              }}
            >
              {ticket.message}
            </p>
          </div>
        </div>

        <ReplyBox ticket={ticket} />
      </Card>
    </>
  );
}
